import PrimaryAddButton from '../core/PrimaryAddButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../core/AddButton';
import CancelButton from '../core/CancelButton';
import Deprecated from '../core/Deprecated';
import PrimaryButton from '../core/PrimaryButton';
import ProjectLanguageSelector from '../core/ProjectLanguageSelector';
import SearchSelect from '../core/SearchSelect';
import { globalStyles } from '../core/style/gstheme';
import TitledPanel from '../core/TitledPanel';
import { isInOntology, checkValidForDatatype } from '../core/utils/utils';
import GS from '../grafsync/grafsync';
import OntologyLink from './OntologyLink';

const styles = Object.assign({}, globalStyles);

class FindResourceDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            offerExternal: false,
            lang: props.viewLang,
            externalDuplicate: false
        };
        this.cancellable = null;
    }

    changeLanguage = (lang) => this.setState({ lang });

    handleClickOpen = () => this.setState({ open: true, externalDuplicate: false, offerExternal: false });

    computeSearch = (value, lang) => {
        let excludeByPath = this.props.excludeByPath && this.props.excludeByPath.length > 0 ?
            this.props.excludeByPath
            :
            this.props.excludeByPathList ?
                this.props.excludeByPathList.map(exclusion => {
                    return {
                        predicate: exclusion,
                        target: this.props.source
                    };
                })
                :
                null;
        let graphList = [this.props.graph];
        // We include the system graph for user for domain and range to allow things like XL Label class to be found
        if (this.props.includeSystemGraph) graphList.push(GS.getActiveSubscription());
        const exludeList = [
            "http://www.w3.org/2002/07/owl#Thing",
            "http://www.w3.org/2002/07/owl#topObjectProperty",
            "http://www.w3.org/2002/07/owl#topDataProperty",
            ...this.props.exclude,
            this.props.source
        ];
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: Array.isArray(this.props.searchClass) ? this.props.searchClass : [this.props.searchClass]
            },
            {
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                ...(value !== "") && {
                    value: value,
                    isExactMatch: false
                }
            }
        ];
        if (this.props.searchExcludeClass && this.props.searchExcludeClass.length > 0) {
            search.push({
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: this.props.searchExcludeClass,
                invert: true
            });
        }
        let fullSearch =
        {
            search,
            graph: graphList,
            ...(excludeByPath) && { excludeByPath },
            excludeSystemNamespaces: true,
            exclude: [...new Set(exludeList)],
            language: lang,
            fast: value === "",
            basicSort: value === "",
            pageSize: 20,
            predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/2000/01/rdf-schema#isDefinedBy",
                "https://grafsync.graphifi.com/schema/gs/visibility"
            ]
        };
        return fullSearch;
    };

    addResource = (id) => {
        this.props.onAddResource(id);
        if (!this.props.allowMultiple) this.exitFindResource();
    };

    exitFindResource = () => this.setState({
        open: false,
        lang: this.props.viewLang,
        externalDuplicate: false,
        offerExternal: false
    });

    addExternal = () => this.addResource(this.state.externalIRI);

    declineExternal = () => this.setState({ text: "", offerExternal: false });

    offerExternal = (iri, valid = true) => {
        if (!valid || iri.includes("graphifi") || (this.props.components && this.props.components.includes(iri))) {
            this.setState({
                externalDuplicate: false,
                offerExternal: false
            });
        }
        else if (this.props.exclude.includes(iri)) {
            this.setState({
                externalDuplicate: true,
                offerExternal: false
            });
        }
        else {
            const isValid = checkValidForDatatype(iri, "http://www.w3.org/2001/XMLSchema#anyURI");
            this.setState({
                externalDuplicate: false,
                offerExternal: isValid,
                externalIRI: iri
            });
        }
    };

    render() {

        const { classes, title, ontologyIRI, icon, viewLang, exclude, allowMultiple, dataTest, sortByLength, permitExternal } = this.props;
        const { offerExternal, externalDuplicate, lang } = this.state;

        return (
            <React.Fragment>
                <AddButton icon={icon} dataTest={dataTest} onClick={() => this.handleClickOpen()} title="Add a new resource" />
                <Dialog
                    data-test="add-resource-dialog"
                    className={classes.dialog}
                    open={this.state.open}
                    maxWidth="lg"
                    classes={{
                        paper: classes.paper,
                        paperWidthLg: classes.largeDialog
                    }}
                    onClose={this.exitFindResource}
                    aria-labelledby="find-resource-dialog-title">
                    <DialogTitle data-test="find-resource-dialog-title" disableTypography className={classes.mainHeading} id="find-resource-dialog-title">Find {title || " Resources"}</DialogTitle>
                    <DialogContent style={{ height: 450, width: 600 }}>
                        <div style={{ height: 350 }}>
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector selectedLang={viewLang} includeLabel={false} onSelect={this.changeLanguage} />
                            </TitledPanel>
                            <SearchSelect
                                key={lang}
                                dataTest="resource-label"
                                focus={true}
                                maxLength={250}
                                sortByLength={sortByLength}
                                wrapped={true}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSecondIcon={(result) => {
                                    if (result.deprecated) return <Deprecated />;
                                    return null;
                                }}
                                listSelectionDisplay={(result, lang) => {
                                    if (result.label[lang]) {
                                        return result.label[lang];
                                    }
                                    else return "";
                                }}
                                listDisplay={(result, lang) => {
                                    const ontology = result.visibility || result.isDefinedBy;
                                    if (result.label[lang]) {
                                        return <div>
                                            <Typography variant="body2">
                                                <Tooltip title={result.id}>
                                                    <span data-test="result-text-words">{result.label[lang]}</span>
                                                </Tooltip>
                                            </Typography>
                                            {
                                                ontology && ontologyIRI && !isInOntology(result.id, ontology, ontologyIRI) &&
                                                <OntologyLink
                                                    key={ontology}
                                                    id={ontology}
                                                    graph={result.inNamedGraph}
                                                    handleNotAvailable={true}
                                                    defaultLang={lang} />
                                            }
                                        </div>;
                                    }
                                    else return <div>
                                        <Typography variant="body2">
                                            <span data-test="result-text-words">{result.id}</span>
                                        </Typography>
                                    </div>;
                                }}
                                sortProp="label"
                                errorText={externalDuplicate ? "This external link already exists." : null}
                                isClickableResult={(result) => !result.invalid && !result.deprecated && !exclude.includes(result.id)}
                                title="Enter text to search"
                                onClearResults={this.declineExternal}
                                onNoResults={this.offerExternal}
                                lang={lang}
                                chosen={this.addResource} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        {allowMultiple ?
                            <PrimaryButton onClick={this.exitFindResource}>Close</PrimaryButton>
                            :
                            <React.Fragment>
                                <CancelButton onClick={this.exitFindResource} />
                                {permitExternal && <PrimaryAddButton title="Add external link" disabled={!offerExternal} onClick={this.addExternal} />}
                            </React.Fragment>
                        }
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindResourceDialog.defaultProps = {
    includeSystemGraph: false,
    allowMultiple: false,
    dataTest: "add-resource",
    sortByLength: true,
    permitExternal: false
};

FindResourceDialog.propTypes = {
    classes: PropTypes.object,
    dataTest: PropTypes.string,
    icon: PropTypes.object,
    excludeByPath: PropTypes.array,
    excludeByPathList: PropTypes.array,
    sortByLength: PropTypes.bool,
    searchClass: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    searchExcludeClass: PropTypes.array,
    ontologyIRI: PropTypes.string,
    components: PropTypes.array,
    exclude: PropTypes.array,
    defaultLang: PropTypes.string,
    source: PropTypes.string,
    title: PropTypes.string,
    viewLang: PropTypes.string,
    graph: PropTypes.string.isRequired,
    includeSystemGraph: PropTypes.bool,
    permitExternal: PropTypes.bool,
    onAddResource: PropTypes.func.isRequired
};

export default withStyles(styles)(FindResourceDialog);